<template>
  <div class="container page">
    <van-nav-bar :title="$t('withdraw.add_bank_card')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="main-box">
      <div class="label">{{$t("withdraw.add_bank_card_tip")}}</div>
      <van-cell-group>
        <van-field
          v-model="bank_name"
          :label="$t('withdraw.bank_name')"
          readonly
          :placeholder="$t('withdraw.select_bank')"
          @click="showBankPicker = true"
        />
        <van-field
          v-model="account_holder"
          :label="$t('withdraw.account_holder')"
          :placeholder="$t('withdraw.account_holder_tip')"
        />
        <van-field
          v-model="account_number"
          :label="$t('withdraw.account_number')"
          type="number"
          :placeholder="$t('withdraw.account_number_tip')"
        />
      </van-cell-group>
      <p>{{$t("withdraw.bank_card_warn")}}</p>
    </div>
    <van-button class="bindCard" type="default" @click="bindBankCard()">{{$t("common.confirm")}}</van-button>

    <!-- 银行选择器 -->
    <van-popup v-model="showBankPicker" round position="bottom" :style="{ height: '60%' }">
      <van-picker
        show-toolbar
        :columns="banks"
        :confirm-button-text="$t('common.confirm')"
        :cancel-button-text="$t('common.cancel')"
        @confirm="onBankConfirm"
        @cancel="showBankPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bank_name: "",
      account_holder: "",
      account_number: "",
      showBankPicker: false,
      banks: [
        'KB국민은행',
        '신한은행',
        '우리은행',
        'KEB하나은행',
        'NH농협은행',
        'IBK기업은행',
        'SC제일은행',
        '씨티은행',
        '카카오뱅크',
        '토스뱅크',
        '케이뱅크',
        '부산은행',
        '경남은행',
        '대구은행',
        '광주은행',
        '전북은행',
        '제주은행',
        '수협은행',
        '우체국'
      ]
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    onBankConfirm(value) {
      this.bank_name = value;
      this.showBankPicker = false;
    },
    bindBankCard(){
      if(!this.bank_name){
        this.$toast.fail(this.$t("withdraw.select_bank"));
        return;
      }
      if(!this.account_holder){
        this.$toast.fail(this.$t("withdraw.account_holder_tip"));
        return;
      }
      if(!this.account_number){
        this.$toast.fail(this.$t("withdraw.account_number_tip"));
        return;
      }
      this.$http({
        method: 'post',
        data: {
          bank: this.bank_name,
          username: this.account_holder,
          bankid: this.account_number
        },
        url: 'user_set_bank'
      }).then(res => {
        if(res.code === 200){
          this.$toast(res.msg);
          this.$router.push({path: '/Withdraw'});
        } else if(res.code === 401){
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path: '/Login'});
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 32px;
  line-height: 80px;
}
.van-hairline--bottom::after {
  border-bottom-width: 3px;
}
.main-box {
  background: #fff;
}
.main-box .label {
  padding: 20px;
  font-size: 35px;
  color: #797878;
}
.main-box p {
  padding: 0 20px;
  font-size: 30px;
  color: #ee0a24;
}
::v-deep .van-picker__toolbar {
  height: 100px;
}
::v-deep .van-picker__cancel, ::v-deep .van-picker__confirm {
  padding: 0 40px;
  font-size: 32px;
}
::v-deep .van-picker-column {
  font-size: 36px;
}
.bindCard {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(90deg, #e6c3a1, #7e5678);
}
</style>
